import type { TestAttemptDto } from "@mmm/contracts";
import { Badge, useT } from "@mmm/ui";
export function TestStatusBadge({ attempts }: { attempts: TestAttemptDto[] }) {
  const t = useT();
  const latest = attempts[attempts.length - 1];
  if (latest?.status === "marked") return <Badge tone="success">{t("tests.statusMarked")}</Badge>;
  if (latest?.status === "submitted") return <Badge tone="today">{t("tests.statusAwaitingMarking")}</Badge>;
  if (latest?.status === "inProgress") return <Badge tone="upcoming">{t("tests.statusInProgress")}</Badge>;
  return <Badge tone="neutral">{t("tests.statusNotStarted")}</Badge>;
}
